<template>
    <div id="search-results" ref="resultsDiv">
      <div v-for="(result, index) in results" :key="result.key">
        <hp5-base-card padding-size-selection="sm" is-elevated="true">
          <keep-alive>
            <component :is="dynamicComponent(result)" v-bind="{ result: result, rank: getIndex(index) }"></component>
          </keep-alive>
        </hp5-base-card>
      </div>
      <BaseFCPPaginator type="searchResults" :pageCount="pageCount" v-model="currentPage" v-if="searchResults && searchResults.length > 0" />
     <div v-if="isVision">
        <ResultsModal :isVision="isVision"/>
    </div>
      <!-- <hp5-spacing-vertical xs="lg"></hp5-spacing-vertical>
      <Questionaire v-if="searchResults && searchResults.length > 10" />
      <hp5-spacing-vertical xs="lg"></hp5-spacing-vertical> -->
    </div>
</template>

<script setup>

    const resultsDiv = ref(null)
    const model = useFCPModel()

    //This is needed for Nuxt to use Dynamic Components. https://nuxt.com/docs/guide/directory-structure/components#dynamic-components
    const ResultsLocationCard = resolveComponent('ResultsLocationCard')
    const ResultsPractitionerCard = resolveComponent('ResultsPractitionerCard')

    const { searchResults, currentPage, context, isVision } = useFCPModel()
    const { pageItems, pageCount,  pageSize } = usePagination(searchResults)
    const results = computed(() => pageItems.value)
    const startValue = computed(() => (currentPage.value - 1) * pageSize.value)
    //calculate appropriate index for each card out of total search results, not just results displayed for that page (i.e. results 1 - 20)
    const getIndex = (index) => {
      return startValue.value + index + 1
    }


    /**
     * We need to render the component based upon the type on the "searchType" attribute on the searchResult.  If we try to use the
     * type in the context, anytime the user changes the "I am looking for a" field in the UI, the searchResults will try to re-render
     * and will probably try to render the wrong component for the searchResults currently in the model.  To prevent this, let
     * the data tell us which type it is.
     */
    const dynamicComponent = (result) => {
        let type = result.searchType
        if (type === 'doctor' || type === 'dentist') return ResultsPractitionerCard
        else return ResultsLocationCard
    }

const term = computed(() => context.value.term)

    function scrollToTop() {
      const element = document.getElementById("horizontal-rule");
      element.scrollIntoView({ behavior: "smooth" });
    }

    //Listen for a change in paging and scroll to the top of the result list.
    watch( currentPage, () => {
      scrollToTop()
    })

    watch([term], () => {
      if(context.value.term == 'Optometry' || context.value.term == 'Optometry (Routine care)' || context.value.term == 'Optometry (Non-routine care)' || context.value.term == 'Pediatric Optometry'  || context.value.term == 'Ophthalmology' ||context.value.term == 'Ophthalmology (Non-routine care)' || context.value.term == 'Pediatric Ophthalmology' )
      {
        model.isVision.value = true
      }else{
        model.isVision.value = false
      }
    })

</script>
  
<style scoped>
  label {
    padding-left: 10px;
  }
  </style>
  
  <style>
  hp5-base-card {
    padding-bottom: var(--spacing-sm);
  }
  hp5-base-card:not(.hydrated) {
    visibility: hidden;
  }
</style>